import {GET_ORGANISATION, UPDATE_ORGANISATION} from 'admin/gql/Organisation.gql'
import {useQuery, useMutation} from 'admin/lib/apollo'

export default (organisationId, {query} = {}) => {
  const {data: {organisation = {}} = {}, error: getError} = useQuery(query || GET_ORGANISATION, {
    variables: {organisationId},
    skip: !organisationId
  })

  const [update, {error: updateError}] = useMutation(UPDATE_ORGANISATION, {
    variables: {organisationId},
    flash: 'Organisation updated'
  })

  return {
    organisation,
    errors: getError || updateError || {},
    update
  }
}
